/** The values that carry text, trimmed, in their original order. */
export function presentValues(...values: (string | null | undefined)[]): string[] {
  return values.map((value) => value?.trim() ?? '').filter((value) => value !== '');
}

/** `First Last`, tolerating a missing or blank last name. */
export function formatPersonName(person: {
  first_name: string;
  last_name?: string | null;
}): string {
  return presentValues(person.first_name, person.last_name).join(' ');
}

/** `AK` for Asad Khalid — the letters an avatar shows. */
export function personInitials(person: { first_name: string; last_name?: string | null }): string {
  return presentValues(person.first_name, person.last_name)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
